<template>
    <z-action-picker
      v-model="showModal"
      height="80vh"
      title="选择对方的商品"
      subTitle="(最多3件)"
      :btn-props="btnProps"
      @confirm="onConfirm"
    >
      <z-list
        v-model="loading"
        :finished="finished"
        @load="onLoad"
        v-if="!showStance"
      >
      <z-checkbox-group v-model="checkboxresult" :max="3" @exceed="onExceed">
        <div
          v-for="(item,index) in productList"
          :key="index"
          class="checkbox-wrap"
          >
          <z-checkbox :name="item.infoId">
            <ProductItem :item="item"></ProductItem>
          </z-checkbox>
        </div>
      </z-checkbox-group>
      </z-list>
      <z-stance v-if="showStance" :show-btn="false" :show-info="false" descText="对方没有在架商品欧~" type="general"></z-stance>
    </z-action-picker>
</template>

<script>
import { getinfolist } from '@api/resourceApi'
import { List, ActionPicker, Checkbox, CheckboxGroup, Stance } from '@zz-common/zz-ui';
import ProductItem from './ProductItem'

export default {
  name: 'ProductList',
  components: {
    'z-list': List,
    'z-action-picker': ActionPicker,
    'z-checkbox': Checkbox,
    'z-checkbox-group': CheckboxGroup,
    'z-stance': Stance,
    ProductItem
  },
  props: ['show'],
  inject: ['sharedData'],
  data() {
    return {
      productList: [],
      loading: false,
      finished: false,
      PageNo: 1,
      checkboxresult: []
    }
  },
  computed: {
    showModal: {
      get() {
        return this.show
      },
      set() {
        this.$emit('close')
      }
    },
    showStance() {
      return this.finished && this.productList.length == 0
    },
    btnProps() {
      if (this.checkboxresult.length > 0) return {}
      return {
        disabled: true
      }
    }
  },
  methods: {
    // 获取商品接口
    getProductInfo() {
      getinfolist({
        infoId: this.sharedData.infoId,
        toUid: this.sharedData.toUid,
        pageNo: this.PageNo++
      })
        .then((res) => {
          this.loading = false
          if (res.length === 0) {
            this.finished = true
            return
          }
          const curInfo = res.find((item) => {
            return item.infoId === this.sharedData.infoId
          })
          if (curInfo) {
            this.checkboxresult.push(curInfo.infoId)
            this.productList.unshift(curInfo)
          }
          this.productList.push(...res.filter(item => item.infoId != this.sharedData.infoId))
        })
        .catch((err) => {
          this.loading = false
          console.error(err)
        })
    },
    onExceed() {
      this.$toast('最多只能选择3个');
    },
    onLoad() {
      this.getProductInfo()
    },
    onConfirm() {
      const data = this.productList.filter((item) => {
        return this.checkboxresult.includes(item.infoId)
      })
      this.$emit('select', data)
      this.$emit('close')
    }
  }
}
</script>
<style lang="less" scoped>
@import "index.less";
</style>